import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import config from './common/config'
import common from './common/common.js'
import echarts from "echarts"
Vue.prototype.$echarts = echarts

// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
// Vue.use(ElementUI);

import i18n from './locale/index'

import _ from "lodash";

// Vue.prototype.$i18n = i18n;

// Vue.use(view-design, {
//   i18n: (key, value) => i18n.t(key, value)
// })

// import 'iview/dist/styles/iview.css'
import 'view-design/dist/styles/iview.css';


import {
    Button,
    Table,
    Switch,
    Card,
    Collapse,
    Cell,
    Menu,
    Dropdown,
    Page,
    Steps,
    Input,
    Radio,
    Checkbox,
    Select,
    DatePicker,
    TimePicker,
    Cascader,
    ColorPicker,
    Form,
    Message,
    Modal,
    Tree,
    Tooltip,
    Poptip,
    Avatar,
    Spin,
    FormItem,
    Sider,
    Layout,
    DropdownMenu,
    DropdownItem,
    Tabs,
    TabPane,
    Upload,
    Icon,
    Progress,
    Row,
    RadioGroup,
    MenuItem,
    Submenu,
    Transfer,
    Breadcrumb,
    BreadcrumbItem,
    CheckboxGroup,
    Timeline,
    Header,
    Option,
    Col,
    TimelineItem,
    Notice,
    Scroll,
    InputNumber,
    Rate
} from 'view-design';
Vue.component('Transfer', Transfer);
Vue.component('Button', Button);
Vue.component('Table', Table);
Vue.component('Card', Card);
Vue.component('Collapse', Collapse);
Vue.component('Cell', Cell);
Vue.component('Menu', Menu);
Vue.component('Dropdown', Dropdown);
Vue.component('Page', Page);
Vue.component('Steps', Steps);
Vue.component('Input', Input);
Vue.component('i-Switch', Switch);
Vue.component('Radio', Radio);
Vue.component('Checkbox', Checkbox);
Vue.component('Select', Select);
Vue.component('DatePicker', DatePicker);
Vue.component('TimePicker', TimePicker);
Vue.component('Cascader', Cascader);
Vue.component('ColorPicker', ColorPicker);
Vue.component('Form', Form);
Vue.component('Message', Message);
Vue.component('Modal', Modal);
Vue.component('Tree', Tree);
Vue.component('Tooltip', Tooltip);
Vue.component('Poptip', Poptip);
Vue.component('Avatar', Avatar);
Vue.component('Spin', Spin);
Vue.component('FormItem', FormItem);
Vue.component('Sider', Sider);
Vue.component('Layout', Layout);
Vue.component('DropdownMenu', DropdownMenu);
Vue.component('DropdownItem', DropdownItem);
Vue.component('Tabs', Tabs);
Vue.component('TabPane', TabPane);
Vue.component('Upload', Upload);
Vue.component('Icon', Icon);
Vue.component('Progress', Progress);
Vue.component('Row', Row);
Vue.component('RadioGroup', RadioGroup);
Vue.component('MenuItem', MenuItem);
Vue.component('Submenu', Submenu);
Vue.component('Breadcrumb', Breadcrumb);
Vue.component('BreadcrumbItem', BreadcrumbItem);
Vue.component('CheckboxGroup', CheckboxGroup);
Vue.component('Timeline', Timeline);
Vue.component('Header', Header);
Vue.component('Option', Option);
Vue.component('Col', Col);
Vue.component('TimelineItem', TimelineItem);
Vue.component('Notice', Notice);
Vue.component('Scroll', Scroll);
Vue.component('InputNumber', InputNumber);
Vue.component('Rate', Rate);



Vue.prototype.$Modal = Modal;
Vue.prototype.$Notice = Notice;
Vue.prototype.$Message = Message;

import deleteModel from './views/common/deleteModel.vue'

// Vue.use(deleteModel);
Vue.prototype.$deleteModel = deleteModel;
Vue.config.productionTip = false;
Vue.prototype.config = config;


axios.defaults.withCredentials = true;
Vue.prototype.axios = axios;

import Print from 'vue-print-nb'
Vue.use(Print);

import Distpicker from 'v-distpicker'
Vue.component('v-distpicker', Distpicker)
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'


import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import VueVirtualScroller from 'vue-virtual-scroller'
Vue.use(VueVirtualScroller)


Vue.prototype.transPrice = common.transPrice; //金额转换   199 ==> 1.99

var option = {
    maxSpreadZoom: 2, // 控制预览图最大的倍数，默认是2倍，我这里改成了原图
    fullscreenEl: true, //控制是否显示右上角全屏按钮
    closeEl: true, //控制是否显示右上角关闭按钮
    tapToClose: true, //点击滑动区域应关闭图库
    shareEl: true, //控制是否显示分享按钮
    zoomEl: true, //控制是否显示放大缩小按钮
    counterEl: true, //控制是否显示左上角图片数量按钮
    arrowEl: true, //控制如图的左右箭头（pc浏览器模拟手机时）
    tapToToggleControls: true, //点击应切换控件的可见性
    clickToCloseNonZoomable: true //点击图片应关闭图库，仅当图像小于视口的大小时
}
Vue.use(preview, option)


import ImageViewer from 'vue2-viewer';
Vue.use(ImageViewer);


// import SearchModel from '@/views/common/searchModel'
// Vue.use(SearchModel);
// Vue.component('SearchModel', SearchModel)


// import EleInput from '@/views/common/eleInput'
// Vue.use(EleInput);
// Vue.component('EleInput', EleInput)


import "./resourse/iconfont/iconfont.css"

import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
    ak: "rQuXse6gpzSHmr1MEC4usOZtPmeULyOa"
})


// // 引入vue-bmap-gl
// import VueBMap from 'vue-bmap-gl';
// import VueMapvgl from 'vue-mapvgl';
// import 'vue-bmap-gl/dist/style.css';
// Vue.use(VueBMap);
// Vue.use(VueMapvgl);

// // 初始化vue-bmap
// VueBMap.initBMapApiLoader({
//   // 百度的key
//   ak: 'rQuXse6gpzSHmr1MEC4usOZtPmeULyOa',
//   // 百度 sdk 版本，默认为 1.0
//   v: '1.0'
// });

// import VueAMap from '@vuemap/vue-amap';
// import '@vuemap/vue-amap/dist/style.css'
// Vue.use(VueAMap);
// VueAMap.initAMapApiLoader({
//   key: '747f980f217a31ba68d99301045a3fa7',
// });




// create an axios instance
axios.defaults.withCredentials = true
if (common.getToken()) axios.defaults.headers.common['Authorization'] = common.getToken();
if (common.getDearlerToken()) axios.defaults.headers.common['Authorization'] = common.getDearlerToken();
// axios.defaults.headers.common['Authorization'] = "eyJhbGciOiJIUzI1NiJ9.eyJjaG9vc2VEZWFsZXJJZCI6MTAwMTksInN1YiI6IjE4MTkwNDA1NjVAcXEuY29tIiwiZGVhbGVySWQiOjEwMDAwLCJjb21wYW55TmFtZSI6IueuoeeQhuWRmCIsInJvbGVUeXBlIjoxLCJleHAiOjE2NjU0NTcyNzQsImlhdCI6MTY2NTQ1MzY3NCwiZW1haWwiOiIxODE5MDQwNTY1QHFxLmNvbSJ9.87DbIafwZizU1CTu8Qbsrwl7BagLIjFtNUvrrIGkWi8"


// 请求的拦截器
axios.interceptors.request.use(function(config) {
    // console.log('config',config)
    // config.headers['Authorization'] = "eyJhbGciOiJIUzI1NiJ9.eyJjaG9vc2VEZWFsZXJJZCI6MTAwMTksInN1YiI6IjE4MTkwNDA1NjVAcXEuY29tIiwiZGVhbGVySWQiOjEwMDAwLCJjb21wYW55TmFtZSI6IueuoeeQhuWRmCIsInJvbGVUeXBlIjoxLCJleHAiOjE2NjU0NTcyNzQsImlhdCI6MTY2NTQ1MzY3NCwiZW1haWwiOiIxODE5MDQwNTY1QHFxLmNvbSJ9.87DbIafwZizU1CTu8Qbsrwl7BagLIjFtNUvrrIGkWi8"

    if(config.url && config.url.includes("/v1/bgfile/downloadLangPackage")){
        config.headers['content-type'] = "application/x-www-form-urlencoded"
        config.responseType = 'blob'
        // responseType: 'blob'
    }else{
        config.headers['content-type'] = "application/json;charset=utf-8"
        config.responseType = 'json'
    }



    // console.log('dealerToken', common.getToken())
    // console.log('dealerToken', common.getDearlerToken())
    let tokenP = new Promise((r, e) => {
        return r(common.getToken())
    })

    let tokenD = new Promise((r, e) => {
        return r(common.getDearlerToken())
    })



    Promise.all([tokenP, tokenD]).then(function(results) {
        // console.log('results,', results) // ["p1 data", ""p2 data""]
        let token = results[0]
        let tokenD = results[1]


        if ((token === false || tokenD === false) && window.nowUrlName != 'login' && window.nowUrlName != 'retrievePwd') {
        //   console.log('window.nowUrlName',window.nowUrlName)

            // 清除数据
            common.removeStorage(store,router)
            
        }

        if (config.method === 'post' && window.nowUrlName != 'login') {
            let data = config.data

            if (Array.isArray(data)) {
                config.data = [...data]
            } else {
                config.data = {
                    ...data
                }
            }


        } else if (config.method === 'get' && window.nowUrlName != 'login') {
            config.params = {
                ...config.params
            }
        } else if (config.method === 'delete' && window.nowUrlName != 'login') {
            config.params = {
                ...config.params
            }
        } else if (config.method === 'patch' && window.nowUrlName != 'login') {
            let data = config.data
            config.data = {
                ...data
            }
        }
        return config;



    })

    

    return config;


}, (error) => {
    return Promise.reject(error);
})




//响应的拦截器
axios.interceptors.response.use((response) => {
    // console.log('response',response)
    // console.log('store.state.TokenInvalidFlag',store.state.TokenInvalidFlag)
    let msgObj = {
        '11009':'Login expired, please login again',
        '13011':'Account logged in elsewhere, please log in again',
        '11007':'The server access token is missing, please log in again'
    }
    if (response.data.code == 11009) { //token过期或者账号在其他地方登录

        if(store.state.TokenInvalidFlag===false){

            store.commit('setTokenInvalidFlag',true) 
            common.msg("error", response.data.message || msgObj[response.data.code], () => {});

            
            let local = localStorage.getItem('local')
            let langSet = localStorage.getItem('langSet')
            let mapType = localStorage.getItem('mapType')
            let centerGeo = localStorage.getItem('centerGeo')
            localStorage.clear();
            sessionStorage.clear();
            store.commit('setTabMenuList', [{ activeId: "0-1", fId: 0, fTitle: "平台首页", name: "平台首页", routeName: "home", routerUrl: "/" }])
            store.commit('setTabMenuItem', { activeId: "0-1", fId: 0, fTitle: "平台首页", name: "平台首页", routeName: "home", routerUrl: "/" })
            document.cookie = "Authorization=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            localStorage.setItem('local', local)
            localStorage.setItem('langSet', langSet)
            localStorage.setItem('mapType',mapType)
            localStorage.setItem('centerGeo',centerGeo)
            router.push({ name: 'login', params: {} })
        }

    }

    if(response.data.code==13011 || response.data.code == 11007){
        if(window.localStorage.loginOut == 'false' || window.localStorage.loginOut == undefined){
            window.localStorage.loginOut = 'true'; // 更改状态，防止发送多次请求，导致消息多次提示
            common.msg("error", response.data.message || msgObj[response.data.code], () => {

                let local = localStorage.getItem('local')
                let langSet = localStorage.getItem('langSet')
                let mapType = localStorage.getItem('mapType')
                let centerGeo = localStorage.getItem('centerGeo')
                localStorage.clear();
                sessionStorage.clear();
                store.commit('setTabMenuList', [{ activeId: "0-1", fId: 0, fTitle: "平台首页", name: "平台首页", routeName: "home", routerUrl: "/" }])
                store.commit('setTabMenuItem', { activeId: "0-1", fId: 0, fTitle: "平台首页", name: "平台首页", routeName: "home", routerUrl: "/" })
                document.cookie = "Authorization=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                localStorage.setItem('local', local)
                localStorage.setItem('langSet', langSet)
                localStorage.setItem('mapType',mapType)
                localStorage.setItem('centerGeo',centerGeo)
                router.push({ name: 'login', params: {} })
            });

        }
    }




    

    
    return response;
}, (error) => {
    // window.sessionStorage.clear(); //清空缓存
    // router.push({ name: 'login' })

    console.log('过期',error)
    common.msg("error", error, () => {});
    return Promise.reject(error)
})


//创建vue实例，将i18n挂载到vue实例上
var vue = new Vue({
    el: "#app",
    i18n,
    router,
    store,
    render: h => h(App)
});

//导出vue实例
export default vue


